module.exports = __webpack_public_path__ + "img/fsm-quest.fc3e4030.jpg";